/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PacketType {
  Unicast = "unicast",
  Broadcast = "broadcast",
  Multicast = "multicast",
}
